app.factory("Session", ["$http",
    function ($http) {
        var Session = {};

        Session.list = function (activation) {
            return $http.get("/session/list/" + activation).then(function (resp) {
                return resp.data;
            });
        };

        Session.groupList = function (activationId) {
            return $http.get("/session/group/list/" + activationId).then(function (resp) {
                return resp.data;
            });
        };

        Session.findGroupById = function (groupId) {
            return $http.get("/session/group/" + groupId).then(function (resp) {
                return resp.data;
            });
        };

        Session.groupListByLecturerId = function (params) {
            return $http.get("/session/group/lecturer/list/" + params.lecturer, {
                params: {
                    season: params.season
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.lecturerTableByLecturer = function (params) {
            return $http.get("/session/lecturer/table/" + params.lecturer, {
                params: {
                    season: params.season
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.groupListBySubjectId = function (subject) {
            return $http.get("/session/group/subject/list/" + subject).then(function (resp) {
                return resp.data;
            });
        };

        Session.evaluationsControl = function (params) {
            return $http.get("/session/evaluations", {
                params: {
                    lecturer: params.lecturer,
                    range: params.range,
                    page: params.page,
                    limit: params.limit
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.save = function (params) {
            return $http.post("/session/group/create", {
                lecturer: params.lecturer,
                title: params.title,
                sessionType: params.sessionType,
                subjectActivation: params.subjectActivation,
                subjectWrapper: params.subjectWrapper,
                subject: params.subject,
                minStudents: params.minStudents,
                maxStudents: params.maxStudents,
                duration: params.duration
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.edit = function (params) {
            return $http.post("/session/group/edit", {
                _id: params._id,
                title: params.title,
                lecturer: params.lecturer,
                sessionType: params.sessionType,
                minStudents: params.minStudents,
                maxStudents: params.maxStudents,
                duration: params.duration,
                zoomUrl: params.zoomUrl
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.remove = function (id) {
            return $http.post("/session/group/remove", {
                "groupId": id
            }).then(function (resp) {
                return resp.data;
            });
        };

        Session.rooms = function (query) {
            return $http.get("/session/room/list", {
                params: {
                    query: query
                }
            }).then(function (resp) {
                return resp.data
            })
        };

        Session.studentSessions = function () {
            return $http.get("/session/student/list").then(function (resp) {
                return resp.data
            })
        };

        Session.moveGroups = function (params) {
            return $http.post("/session/group/move", {
                subjectFrom: params.subjectFrom,
                subjectTo: params.subjectTo
            }).then(function (resp) {
                return resp.data;
            })
        };

        Session.sessionGroupPosts = function (params) {
            return $http.get("/session/group/posts", {
                params: {
                    lecturer: params.lecturer,
                    page: params.page,
                    limit: params.limit
                }
            }).then(function (resp) {
                return resp.data;
            })
        };

        Session.setZoomUrl = function (params) {
            return $http.post("/session/group/zoomUrl", {
                _id: params._id,
                zoomUrl: params.zoomUrl,
                archiveUrl: params.archiveUrl
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Session;
    }
]);
